module.exports = __webpack_public_path__ + "static/logo-e45e94f6e6acc902cb7b3942b4bb085e.png";